



import { EntityState, EntityAdapter, createEntityAdapter, Update } from '@ngrx/entity';
import { createReducer, on  } from '@ngrx/store';
import { get } from 'lodash';

import { CollectionScreenState } from '@core/store';


import * as fromMaster from './master-search-0.actions';
import * as fromStore from '@app/core/store';
import * as featureAdapter from '@core/store/feature-adapter';

export interface State extends EntityState<CollectionScreenState<any>> { }
export const adapter: EntityAdapter<CollectionScreenState<any>> = createEntityAdapter<CollectionScreenState<any>>({});

export const initialState: State = adapter.getInitialState();

const _reducer = createReducer(initialState,
    on(fromMaster.initAction, (state, payload) => adapter.addOne(payload, state)),
on(fromMaster.destroyAction, (state, payload) => adapter.removeOne(payload, state)),

    
    
    on( fromMaster.rowsSelectionChangeAction, (state, payload) => {
      const changes = { rowsSelected: payload.rowsSelected };
      return adapter.updateOne(
        {
          id: payload.id,
          changes: changes
        },
        state
      );
    }),
      on( fromMaster.countSuccessAction, (state, payload) => {
      const changes = {
        totalItems: payload['totalItems']
      };
      return adapter.updateOne({
        id: payload.id,
        changes: changes,
      }, state);
    }),
    on( fromMaster.searchAction,(state, payload) => {
      return adapter.updateOne(
        {
          id: payload.id,
          changes: {loading: true},
        },
        state,
      );
    }),
    on( fromMaster.searchSuccessAction,(state, payload) => {
      const changes = {
        value: payload.value,
        loading: false,
        rowId: null,
        vars: {
          size: payload.size,
          page: payload.page,
        }
      };
      return adapter.updateOne({
        id: payload.id,
        changes: changes,
        }, state);
      }),
    on( fromMaster.searchFailAction, (state, payload) => {
      const changes = {
        value: [],
        loading: false
      };
      return adapter.updateOne(
        {
          id: payload.id,
          changes: changes
        },
        state
      );
    })
);
export function reducer(state, action) {
  return _reducer(state, action);
}


